import React from 'react';
import { Box, Typography, styled } from '@mui/material';

const ProgressTrack = styled(Box)(({ theme }) => ({
  height: '24px',
  width: '100%',
  backgroundColor: '#E5E7EB',
  borderRadius: '12px',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
}));

const ProgressFill = styled(Box)(({ theme, width }) => ({
  height: '100%',
  width: `${width}%`,
  backgroundColor: '#172664',
  borderRadius: '12px',
  transition: 'width 0.5s ease-in-out',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '12px',
  whiteSpace: 'nowrap',
}));

const FunnelItem = ({ title, value, total, unit = "sessions", suffix = "", showDrop = false, showTotalInBar = false }) => {
  const percentage = total > 0 ? Math.round((value / total) * 100) : 0;
  const dropValue = total - value;
  const dropPercentage = 100 - percentage;

  // 當百分比低於 20% 時，將文字移到進度條外部以確保清晰度
  const isLowPercentage = percentage < 20;

  const textContent = showTotalInBar
    ? `${value.toLocaleString()} / ${total.toLocaleString()} ${unit}`
    : `${value.toLocaleString()} ${unit}`;

  return (
    <Box sx={{ mb: 2, width: '100%' }}>
      <Typography sx={{ fontWeight: 'bold', color: '#1C1C1E', mb: 0.5, fontSize: '13px' }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box sx={{ flexGrow: 1 }}>
          <ProgressTrack>
            <ProgressFill width={percentage}>
              {!isLowPercentage && (
                <Typography sx={{ color: '#FFFFFF', fontSize: '11px', fontWeight: 500 }}>
                  {textContent}
                </Typography>
              )}
            </ProgressFill>
            {isLowPercentage && (
              <Typography sx={{
                color: '#4A5568',
                fontSize: '11px',
                fontWeight: 500,
                position: 'absolute',
                left: `calc(${percentage}% + 12px)`,
                whiteSpace: 'nowrap'
              }}>
                {textContent}
              </Typography>
            )}
          </ProgressTrack>
        </Box>
        <Box sx={{ minWidth: '100px' }}>
          <Typography sx={{ fontWeight: 'bold', color: '#172664', fontSize: '13px' }}>
            {percentage}% {suffix}
          </Typography>
        </Box>
      </Box>
      {showDrop && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.2, pr: '115px' }}>
          <Typography sx={{ color: '#718096', fontSize: '11px' }}>
            Drop: {dropValue.toLocaleString()} ({dropPercentage}%)
          </Typography>
        </Box>
      )}
    </Box>
  );
};

const FunnelProgressBar = ({ attempts, success }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <FunnelItem
        title="Success (Internet Access Granted)"
        value={success}
        total={attempts}
        suffix="Success"
        showDrop={true}
        showTotalInBar={true}
      />
    </Box>
  );
};

export default FunnelProgressBar;
